var _defs, _rect, _path, _path2, _rect2, _rect3, _rect4, _rect5, _g, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoMiot({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "MinervaIoT_Logo",
    "data-name": "MinervaIoT Logo",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 412,
    height: 48.467,
    viewBox: "0 0 412 48.467",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#474b4f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.592,
    stopColor: "#5f8f48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70c143"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_141",
    "data-name": "Rectangle 141",
    width: 7.068,
    height: 48.251,
    transform: "translate(64.635 0.021)",
    fill: "#474b4f"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3737",
    "data-name": "Path 3737",
    d: "M194.855,1148.517v-25.55l6.835-6.807v32.371Zm-37.215-29.777v29.908H151.18V1100.39l25.231,24.887,25.231-24.887v10.554l-25.231,25.2Z",
    transform: "translate(-151.18 -1100.364)",
    fill: "#474b4f"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3738",
    "data-name": "Path 3738",
    d: "M398.22,1148.507v-32.369l7.069,8.279v24.09Zm0-37.578V1100.38l33.977,40.2v-40.2h7.222v48.252h-8.832Z",
    transform: "translate(-313.237 -1100.36)",
    fill: "#474b4f"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_142",
    "data-name": "Rectangle 142",
    width: 7.068,
    height: 48.251,
    transform: "translate(139.078 0.021)",
    fill: "#474b4f"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_143",
    "data-name": "Rectangle 143",
    width: 21.704,
    height: 7.282,
    transform: "translate(149.868 0.021)",
    fill: "#474b4f"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_144",
    "data-name": "Rectangle 144",
    width: 21.704,
    height: 7.151,
    transform: "translate(149.868 20.958)",
    fill: "#474b4f"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_145",
    "data-name": "Rectangle 145",
    width: 21.704,
    height: 7.28,
    transform: "translate(149.868 40.993)",
    fill: "#474b4f"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_218",
    "data-name": "Group 218",
    transform: "translate(319.171 0.021)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3739",
    "data-name": "Path 3739",
    d: "M1149.656,1130a19.076,19.076,0,0,1,19.146,19.186,18.585,18.585,0,0,1-1.489,7.411,19.041,19.041,0,0,1-10.175,10.157,19.308,19.308,0,0,1-14.943,0,19.1,19.1,0,0,1-10.148-10.158,18.555,18.555,0,0,1-1.494-7.41,19.112,19.112,0,0,1,11.641-17.683,18.6,18.6,0,0,1,7.46-1.5Zm0,32.911a12.526,12.526,0,0,0,5.151-1.084,13.518,13.518,0,0,0,4.239-2.945,13.881,13.881,0,0,0,2.853-4.364,13.715,13.715,0,0,0,1.046-5.346,13.883,13.883,0,0,0-1.046-5.371,14.088,14.088,0,0,0-2.853-4.407,13.307,13.307,0,0,0-4.237-2.97,12.518,12.518,0,0,0-5.151-1.084,12.375,12.375,0,0,0-5.13,1.084,13.384,13.384,0,0,0-4.209,2.97,14.076,14.076,0,0,0-2.853,4.412,13.886,13.886,0,0,0-1.044,5.37,13.7,13.7,0,0,0,1.044,5.346,13.885,13.885,0,0,0,2.853,4.364,13.639,13.639,0,0,0,4.209,2.943,12.326,12.326,0,0,0,5.13,1.082Z",
    transform: "translate(-1112.806 -1119.811)",
    fill: "#70c143"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_146",
    "data-name": "Rectangle 146",
    width: 7.304,
    height: 48.251,
    transform: "translate(69.714)",
    fill: "#70c143"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147",
    "data-name": "Rectangle 147",
    width: 7.304,
    height: 48.251,
    fill: "#70c143"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148",
    "data-name": "Rectangle 148",
    width: 12.673,
    height: 6.654,
    transform: "translate(53.906)",
    fill: "#70c143"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_149",
    "data-name": "Rectangle 149",
    width: 12.673,
    height: 6.654,
    transform: "translate(80.156)",
    fill: "#70c143"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3740",
    "data-name": "Path 3740",
    d: "M697.981,1100.378v48.186H690.91v-48.186Zm28.884,48.252h-9.129L701.6,1127.72h7.563c1.456,0,11.182-.36,11.182-10.095a10.587,10.587,0,0,0-11.182-10.6H701.6v-6.665h6.7c3.962,0,18.3,1.642,18.3,17.182a16.3,16.3,0,0,1-11.759,16.008Z",
    transform: "translate(-505.238 -1100.361)",
    fill: "#474b4f"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3741",
    "data-name": "Path 3741",
    d: "M954.064,1100.38l21.135,48.252h-7.867l-13.261-29.32-13.261,29.32H932.94Zm3.457,40.905h-6.835v7.346h6.835Z",
    transform: "translate(-664.009 -1100.359)",
    fill: "url(#linear-gradient)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3742",
    "data-name": "Path 3742",
    d: "M836.915,1148.629l-21.135-48.252h7.868l13.261,29.319,13.261-29.319h7.879Z",
    transform: "translate(-587.152 -1100.367)",
    fill: "#474b4f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMiot);
export default __webpack_public_path__ + "static/media/logo_miot.0c4f7f53a833203b5b328f0e9a0a76a9.svg";
export { ForwardRef as ReactComponent };